import styled from "styled-components";

export const FieldTitle = styled.span`
  font-family: "Avenir Black", sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
`;
